<template>
  <v-dialog v-model="confirmState.show" max-width="420" persistent>
    <v-card>
      <v-card-title>{{ confirmState.title }}</v-card-title>
      <v-card-text>{{ confirmState.message }}</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="respond(false)">Cancel</v-btn>
        <v-btn color="error" text @click="respond(true)">{{ confirmState.confirmText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { confirmState } from '../plugins/confirm';

export default {
  name: 'ConfirmDialog',
  data() {
    return { confirmState };
  },
  methods: {
    respond(value) {
      confirmState.show = false;
      if (confirmState.resolve) {
        confirmState.resolve(value);
        confirmState.resolve = null;
      }
    },
  },
};
</script>
